module.exports = __webpack_public_path__ + "img/3.2fbd5ad8.png";